import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import RegistrationProfileHeroImage from '../../../../assets/images/registration-profile-hero.png';
import { rubikTypographyStyles } from '../../../../shared/ui';

type HeroBadgeProps = {
  $left?: number;
  $maxWidth: number;
  $minHeight: number;
  $minWidth: number;
  $paddingX: number;
  $paddingY: number;
  $radius: number;
  $right?: number;
  $top: number;
  $whiteSpace: 'nowrap' | 'pre-line';
};

const Slide = styled.section.attrs({
  'data-ui': 'onboarding-welcome-slide',
})`
  display: grid;
  gap: ${({ theme }) => theme.scale.px(47)};
`;

const Title = styled.h1`
  ${rubikTypographyStyles};
  margin: 0;
  width: ${({ theme }) => theme.scale.px(295)};
  margin-left: ${({ theme }) => theme.scale.px(31)};
  font-size: ${({ theme }) => theme.scale.px(24)};
  font-weight: 600;
  line-height: ${({ theme }) => theme.scale.px(28)};
  white-space: pre-line;
`;

const Hero = styled.div`
  width: ${({ theme }) => theme.scale.px(308)};
  align-self: flex-start;
  margin-left: ${({ theme }) => theme.scale.px(44)};
  position: relative;
`;

const HeroImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

const HeroBadge = styled.p<HeroBadgeProps>`
  ${rubikTypographyStyles};
  margin: 0;
  position: absolute;
  top: ${({ $top, theme }) => theme.scale.px($top)};
  left: ${({ $left, theme }) =>
    $left === undefined ? 'auto' : theme.scale.px($left)};
  right: ${({ $right, theme }) =>
    $right === undefined ? 'auto' : theme.scale.px($right)};
  width: fit-content;
  min-width: ${({ $minWidth, theme }) => theme.scale.px($minWidth)};
  max-width: ${({ $maxWidth, theme }) => theme.scale.px($maxWidth)};
  min-height: ${({ $minHeight, theme }) => theme.scale.px($minHeight)};
  box-sizing: border-box;
  padding: ${({ $paddingY, theme }) => theme.scale.px($paddingY)}
    ${({ $paddingX, theme }) => theme.scale.px($paddingX)};
  display: flex;
  align-items: center;
  border-radius: ${({ $radius, theme }) => theme.scale.px($radius)};
  background: ${({ theme }) => theme.colors.surface.base};
  box-shadow: 0 ${({ theme }) => theme.scale.px(4)}
    ${({ theme }) => theme.scale.px(4)}
    ${({ theme }) => theme.colors.surface.overlay};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.scale.px(16)};
  font-weight: 500;
  line-height: ${({ theme }) => theme.scale.px(18)};
  white-space: ${({ $whiteSpace }) => $whiteSpace};
`;

export function WelcomeSlide() {
  const { t } = useTranslation();

  return (
    <Slide>
      <Title>{t('registrationProfile.title')}</Title>

      <Hero>
        <HeroImage alt="" aria-hidden src={RegistrationProfileHeroImage} />

        <HeroBadge
          $left={-25}
          $maxWidth={150}
          $minHeight={49}
          $minWidth={0}
          $paddingX={12}
          $paddingY={7}
          $radius={15}
          $top={144}
          $whiteSpace="pre-line"
        >
          {t('registrationProfile.heroNoFee')}
        </HeroBadge>

        <HeroBadge
          $left={35}
          $maxWidth={140}
          $minHeight={28}
          $minWidth={0}
          $paddingX={12}
          $paddingY={5}
          $radius={11}
          $top={328}
          $whiteSpace="nowrap"
        >
          {t('registrationProfile.heroFree')}
        </HeroBadge>

        <HeroBadge
          $maxWidth={150}
          $minHeight={61}
          $minWidth={127}
          $paddingX={10}
          $paddingY={7}
          $radius={15}
          $right={-38}
          $top={64}
          $whiteSpace="pre-line"
        >
          {t('registrationProfile.heroCallout')}
        </HeroBadge>

        <HeroBadge
          $maxWidth={130}
          $minHeight={50}
          $minWidth={80}
          $paddingX={12}
          $paddingY={7}
          $radius={15}
          $right={-10}
          $top={212}
          $whiteSpace="pre-line"
        >
          {t('registrationProfile.heroSafe')}
        </HeroBadge>
      </Hero>
    </Slide>
  );
}
